import React from 'react'

/**
 * The shared skeleton shimmer: a highlight sweeping over a pulsing block. The
 * keyframes are injected once rather than declared in the feature's stylesheet,
 * so the loading markup stays Tailwind-only and can be imported from the main
 * bundle without pulling HomeHighlight.scss in with it.
 */
const SHIMMER_STYLES = `
  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`

if (typeof document !== 'undefined' && !document.getElementById('shimmer-styles-home-highlight')) {
  const style = document.createElement('style')
  style.id = 'shimmer-styles-home-highlight'
  style.textContent = SHIMMER_STYLES
  document.head.appendChild(style)
}

export const ShimmerEffect = ({ className = '', children }) => (
  <div className={`relative overflow-hidden ${className}`}>
    {children}
    <div
      className="absolute inset-0 bg-gradient-to-r from-transparent via-Neutral-3/30 to-transparent"
      style={{
        animation: 'shimmer 2s infinite',
        transform: 'translateX(-100%)',
      }}
    />
  </div>
)

/**
 * A single placeholder block: the shimmer over a pulsing surface. The radius is
 * left to the caller so a round or a squared-off block cannot end up fighting a
 * default `rounded` for the same property.
 */
export const ShimmerBlock = ({ className = '' }) => (
  <ShimmerEffect className={`bg-surface-3 ${className}`}>
    <div className="animate-pulse h-full w-full bg-Neutral-3 opacity-60" />
  </ShimmerEffect>
)

export default ShimmerEffect
